/* PROPS
    1. bg -> CSS background color
    2. verticalPadding -> adds padding to top and bottom of entrypoint container
    3. breakpointContainer -> Boolean to wrap element in breakpoint container
*/
import React from 'react';

const EntrypointWrapper = (props) => { 
    return(
        <div style={{
            background: props.bgColor,
            paddingTop: props.verticalPadding,
            paddingBottom:props.verticalPadding
        }}>
            {props.breakpointContainer 
                ? 
                <div className={`custom-breakpoint-container ${props.className ? props.className : ''}`}>{props.children}</div>
                : 
                props.children
            }
        </div>
    )
}
export default EntrypointWrapper;